import { BrowserRouter, Route, Routes} from "react-router-dom"



import Home from "./pages/Home.js"
import Success from "./pages/Success.js"
import CotAuto from "./pages/CotAuto.js"
import AppTest from "./pages/AppTest.js"
import Construction from "./pages/Contruction.js"



export default function Rotas(){
    return(
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Home/>}/> 
                <Route path="/success"  element={<Success/>}/> 
                <Route path="/auto"  element={<CotAuto/>}/> 
                <Route path="/test"  element={<AppTest/>}/> 
                <Route path="/construction"  element={<Construction/>}/> 




            </Routes>
        </BrowserRouter>
    )
}